import api, {graphqlQueryBuild} from '../../services/api';

export const LOAD_EPISODE = 'LOAD_EPISODE';
export const ADD_EPISODE_FAVOURITE = 'ADD_EPISODE_FAVOURITE';
export const REMOVE_EPISODE_FAVOURITE = 'REMOVE_EPISODE_FAVOURITE';

export const loadEpisode = episode_id => {
    return async (dispatch, getState) => {
        dispatch({
            type: LOAD_EPISODE,
            payload: {loading: true, episode: undefined},
        });

        // needed fields
        // metadataLanguage
        // contentProvider
        // type
        let query = graphqlQueryBuild(
            'vod',
            `id
            title
            image
            duration
            episode
            season
            description
            genres
            contentRating
            externalId

            show {
                id
                title
                image
                description
            }`,
            `id: ${episode_id}`,
        );

        let episode_response = await api
            .get('', {
                params: {
                    query,
                },
            })
            .then(res => res)
            .catch(err => err.response);

        if (episode_response.data?.data?.vod) {
            episode_response.data.data.vod.objectSubtype =
                episode_response.data.data.vod.season >= 1 &&
                episode_response.data.data.vod.episode >= 1
                    ? 'VIDEO'
                    : 'MOVIE';
        }

        dispatch({
            type: LOAD_EPISODE,
            payload: {
                loading: false,
                error: episode_response.status !== 200,
                episode: episode_response.data?.data?.vod || null,
            },
        });

        return episode_response;
    };
};
